import { Rectangle, PolyLine, Circle, Line, PolarLine, Arc, Text } from "./utils"
import { sayacUcFaz, sayacTekFaz, aos3F, aos1F, yks3F, yks1F, vida, tms } from "./views";
import { dimentionHorTextBottom, dimentionVertTextRight } from "./utils";

 
// Layer sistemı 
const layers = {
  0: { name: '0', frozen: false, visible: true, colorIndex: 7, color: 16777215 },
  18: { name: '18', frozen: false, visible: true, colorIndex: 1, color: 16711680 },
  AKSYAZI: { name: 'AKSYAZI', frozen: false, visible: true, colorIndex: 9, color: 12632256 }
};

const layer = layers.AKSYAZI;
const options = {
  color: layer.color,
  colorIndex: layer.colorIndex,
  layer: layer.name,
  shape: true,
  hasContinuousLinetypePattern: false
};

const symbolOptions = {
  ...options,
  color: 0x00ff00,
  colorIndex: 3
};
// Ana pano detay çizim fonksiyonu
export const createPanoDetay = (data) => {
  let result = [];
  const Scl = 2;

  // createKolonSema uyumlu veri yapısı
  const feeder = data.feeder || {};
  const branchies = data.branchies || [];
  const phaseCount = data.phaseCount || 1;

  // Ana X,Y konumlandırma
 
  const frameInnerOffset = 1 * Scl

  const dimOffset = 10 * Scl;
  const dimHeight = 15 * Scl;
  const gap = 30 * Scl;
  // Pano boyutları 
  const panelWidth = 40 * Scl
  const panelHeight = 60 * Scl 
  const headerHeight = 50  

  result.push(Line(0, headerHeight, 1 , headerHeight, options));
    let text = {
    text: data.kolonDetails.panelName||"Sayaç Panosu",
    x: gap +   dimOffset + dimHeight   ,
    y: -gap/2  ,
    textHeight: 8 * Scl,
    id: `title_text_ `
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));
  result.push(...dimentionHorTextBottom(
    gap + panelWidth / 2 + dimOffset + dimHeight,    //X
    -gap - panelHeight,     //Y
    Scl,
    panelWidth, //LENGHT
    dimHeight,   //HEİGHT
    dimOffset, //OFSET
    options     //OPTION
  ));
  result = result.concat(dimentionVertTextRight(
    gap + dimHeight + dimOffset,
    -gap - panelHeight / 2,
    Scl,
    panelHeight,
    dimHeight,
    dimOffset,
    options
  ));
  // 3D Panel çizimi
  result.push(Rectangle(
    gap + dimHeight + dimOffset,
    -gap,
    panelWidth,
    -panelHeight,
    { shape: true }
  ))
  result.push(Rectangle(
    gap + dimHeight + dimOffset + frameInnerOffset,
    -gap - frameInnerOffset,
    panelWidth - 2 * frameInnerOffset,
    -panelHeight + 2 * frameInnerOffset,
    { shape: true }
  ))
  let centerX = gap + dimHeight + dimOffset + panelWidth / 2
  let centerY = -gap - frameInnerOffset - 30 * Scl
  const sayacScl = 0.1
  const fuseScl = 0.2

  if (phaseCount === 3) {
    result.push(...sayacUcFaz(centerX - 0 * Scl * sayacScl / 2, centerY, Scl * sayacScl, 0, symbolOptions));
    result.push(...yks3F(centerX - 15 * Scl * fuseScl, centerY - 5 * Scl, Scl * fuseScl, 0, symbolOptions));
    result.push(...aos3F(centerX - 14 * Scl * fuseScl, centerY - 17 * Scl, Scl * fuseScl, 0, symbolOptions));

  } else {
    result.push(...sayacTekFaz(centerX - 0 * Scl * sayacScl / 2, centerY, Scl * sayacScl, 0, symbolOptions));
    result.push(...yks1F(centerX - 5 * Scl * fuseScl, centerY - 5 * Scl, Scl * fuseScl, 0, symbolOptions));
    result.push(...aos1F(centerX - 4 * Scl * fuseScl, centerY - 17 * Scl, Scl * fuseScl, 0, symbolOptions));

  }



  result.push(...vida(gap + dimHeight + dimOffset + frameInnerOffset / 2, -gap - frameInnerOffset / 2, Scl * 0.1, 2, options));
  result.push(...vida(gap + dimHeight + dimOffset - frameInnerOffset / 2 + panelWidth, -gap - frameInnerOffset / 2, Scl * 0.1, 2, options));
  result.push(...vida(gap + dimHeight + dimOffset + frameInnerOffset / 2, -gap + frameInnerOffset / 2 - panelHeight, Scl * 0.1, 2, options));
  result.push(...vida(gap + dimHeight + dimOffset - frameInnerOffset / 2 + panelWidth, -gap + frameInnerOffset / 2 - panelHeight, Scl * 0.1, 2, options));

  let fuseBoxWidth = 20 * Scl
  const fuseBoxHeight = 10 * Scl

     //-------------- KAPAK ----------------------------------
   const  vertices=[
    { x:gap + dimHeight + dimOffset + panelWidth,y:-gap ,z:0 },
    { x:gap + dimHeight + dimOffset + panelWidth*1.6,y:-gap*1.4 ,z:0 },
    { x:gap + dimHeight + dimOffset + panelWidth*1.6,y:-gap*1.4-panelHeight ,z:0 },
    { x:gap + dimHeight + dimOffset + panelWidth,y:-gap-panelHeight ,z:0 },
  ]
  options.shape=false
   result.push(PolyLine(gap + dimHeight + dimOffset + panelWidth,-gap,vertices,options))
  //-------------------- FUSE BOX -------------------------
  centerX = 2 * gap + dimHeight + dimOffset + panelWidth
      text = {
    text: feeder?.panelNames?.[0] ,
    x: centerX   ,
    y: -gap  ,
    textHeight: 8 * Scl,
    id: `title_text_ `
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));
  let f1width = 10 * Scl * fuseScl
  let f3width = 30 * Scl * fuseScl
  let currentFuseX = centerX  

  if (phaseCount === 3) {
    result.push(...yks3F(centerX + 2.8 * Scl, -gap - frameInnerOffset - 12 * Scl, Scl * fuseScl, 0, symbolOptions));
    result.push(...aos3F(centerX + 10 * Scl, -gap - frameInnerOffset - 12 * Scl, Scl * fuseScl, 0, symbolOptions));
    currentFuseX+=91*Scl*fuseScl

  } else {
    result.push(...yks1F(centerX + 3.5 * Scl, -gap - frameInnerOffset - 12 * Scl, Scl * fuseScl, 0, symbolOptions));
    result.push(...aos1F(centerX + 8 * Scl, -gap - frameInnerOffset - 12 * Scl, Scl * fuseScl, 0, symbolOptions));
    currentFuseX+=51*Scl*fuseScl

  }


  branchies.forEach(branch => {

    if (branch.phaseCount === 1) {
      result.push(...aos1F(currentFuseX, -gap - frameInnerOffset - 12 * Scl, Scl * fuseScl, 0, symbolOptions));
      currentFuseX += f1width
      fuseBoxWidth += f1width
    }else if (branch.phaseCount === 3) {
      result.push(...aos3F(currentFuseX, -gap - frameInnerOffset - 12 * Scl, Scl * fuseScl, 0, symbolOptions));
      currentFuseX += f3width
      fuseBoxWidth += f3width
    }

  })
  result.push(Rectangle(
    centerX,
    -gap - frameInnerOffset - 6 * Scl,
    fuseBoxWidth,
    -fuseBoxHeight,
    { shape: true }
  ))
  centerX++
  result.push(Rectangle(
    centerX,
    -gap - frameInnerOffset - 7 * Scl,
    fuseBoxWidth - 2 * Scl,
    -fuseBoxHeight + 2 * Scl,
    { shape: true }
  ))
 
    const docWidth = centerX+gap*2
    const docHeight = panelHeight + 2 *gap+dimHeight+dimOffset+headerHeight

//-------------HEADER ------------------
  const headerTextWidth=200 

     text = {
    text: "PANO DETAY",
    x:docWidth/2-headerTextWidth/2   ,
    y: headerHeight/2   ,
    textHeight:22.5 ,
    id: `title_text_header`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));



  //-------------------------DOCFRAME-------------
   const  vertices2=[
      { x:0,y:headerHeight ,z:0 },
      { x:0,y:-docHeight+headerHeight ,z:0 },
      { x:docWidth,y:-docHeight+headerHeight ,z:0 },
      { x:docWidth,y:headerHeight ,z:0 },
    ]
    options.shape=true
    result.push(PolyLine(0,0,vertices2,options))
    result.push(PolarLine(0, 0, 0,docWidth, options));
  return {
    result: result,
    width: docWidth,
    height: docHeight,
  };
};


















